import styled from 'styled-components';

export const UnderlineText = styled.span`
  font-size: inherit;
  font-family: 'Varela Round', sans-serif;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 700;
  color: ${props => props.theme.primaryColor};
  transition: border-bottom 0.3s ease;
  cursor: pointer;

  &:hover {
    border-bottom: 3px solid ${props => props.theme.primaryColor};
  }
`;
